import script from "./notepadWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./notepadWindow.vue?vue&type=script&setup=true&lang=js"

import "./notepadWindow.vue?vue&type=style&index=0&id=44cecc27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44cecc27"]])

export default __exports__